export default __webpack_public_path__ + "static/media/ic-responses.1290f72c.svg";